import { createContext, useContext, useState } from "react";

export const MapContext = createContext({});

export const useMapContext = () => {
  return useContext(MapContext);
};

export const MapContextProvider = ({ children }) => {
  const [map, setMap] = useState(null);

  const MapContextValue = [map, setMap];

  return (
    <MapContext.Provider value={MapContextValue}>
      {children}
    </MapContext.Provider>
  );
};
